<template>
  <div class="personnel">
    <div class="applicantInfoFormTitle">
      <h1>法定代表人信息</h1>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>姓名<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form1.name" placeholder="请输入姓名"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>证件号<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form1.codeId" placeholder="请输入证件号"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司人员规模<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-select v-model="form1.codeType" placeholder="请选择">
          <el-option
            v-for="item in staffSizeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>手机号码<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form1.phone" placeholder="请输入手机号码"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>邮箱<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form1.email" placeholder="请输入邮箱地址"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>身份证<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList1"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <!-- 、、、、、、、、、、、、、、、、、、、、、、、、、 -->

    <div class="applicantInfoFormTitle">
      <h1>许可证负责人信息</h1>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>姓名<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form2.name" placeholder="请输入姓名"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>证件号<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form2.codeId" placeholder="请输入证件号"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司人员规模<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-select v-model="form2.codeType" placeholder="请选择">
          <el-option
            v-for="item in staffSizeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>手机号码<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form2.phone" placeholder="请输入手机号码"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>邮箱<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form2.email" placeholder="请输入邮箱地址"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>身份证<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList2"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <!-- 。。。。。。。。。。。。。。。。。。。。。。。。。。。 -->

    <div class="applicantInfoFormTitle">
      <h1>客服负责人信息</h1>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>姓名<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form3.name" placeholder="请输入姓名"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>证件号<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form3.codeId" placeholder="请输入证件号"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司人员规模<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-select v-model="form3.codeType" placeholder="请选择">
          <el-option
            v-for="item in staffSizeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>手机号码<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form3.phone" placeholder="请输入手机号码"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>邮箱<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form3.email" placeholder="请输入邮箱地址"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>身份证<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList3"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <!-- 、、、、、、、、、、、、、、、、、、、、、、、、、、 -->

    <div class="applicantInfoFormTitle">
      <h1>安全负责人信息</h1>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>姓名<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form4.name" placeholder="请输入姓名"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>证件号<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form4.codeId" placeholder="请输入证件号"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司人员规模<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-select v-model="form4.codeType" placeholder="请选择">
          <el-option
            v-for="item in staffSizeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>手机号码<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form4.phone" placeholder="请输入手机号码"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>邮箱<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input v-model="form4.email" placeholder="请输入邮箱地址"></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>身份证<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList4"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <!-- ///////////////////////////////////// -->

    <div class="applicantInfoFormTitle">
      <h1>社保证明文件</h1>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>身份证<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList5"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <div class="formItemNext">
      <button @click="$router.go(-1)">上一步</button>
      <button @click="$router.push('/icpfillmaterials/shareholder')">
        下一步
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //表单绑定
      form1: {
        name: '',
        codeId: '',
        codeType: '',
        phone: '',
        email: ''
      },
      form2: {
        name: '',
        codeId: '',
        codeType: '',
        phone: '',
        email: ''
      },
      form3: {
        name: '',
        codeId: '',
        codeType: '',
        phone: '',
        email: ''
      },
      form4: {
        name: '',
        codeId: '',
        codeType: '',
        phone: '',
        email: ''
      },
      //公司人员规模
      staffSizeList: [
        {
          value: 0,
          label: '身份证'
        },
        {
          value: 1,
          label: '护照'
        },
        {
          value: 2,
          label: '港澳居民往来内地通行证或港澳身份证'
        },
        {
          value: 3,
          label: '台湾居民往来内地通行证或台湾身份证'
        }
      ],
      //图片
      fileList1: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ],
      fileList2: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ],
      fileList3: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ],
      fileList4: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ],
      fileList5: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('qffillmaterials/changeActivedIndex', 2);
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>

<style lang="scss">
.personnel {
  width: 100%;
  background: #fff;
  padding: 4px 0;
  margin-bottom: 60px;
  .applicantInfoFormTitle {
    width: 100%;
    padding-left: 245px;
    padding-top: 20px;
    h1 {
      padding-left: 10px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(38, 38, 38, 1);
      letter-spacing: 1px;
      border-left: 3px solid #fe6a01;
    }
  }
  .applicantInfoFormItem {
    width: 100%;
    display: flex;
    padding: 16px;
    .formItemLeftTitle {
      width: 438px;
      height: 32px;
      p {
        text-align: right;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
        padding-right: 10px;
        span {
          color: #f00;
          margin-left: 5px;
          line-height: 32px;
        }
      }
    }
    .formItemRightMain {
      flex: 1;
      display: flex;
      align-items: center;
      .el-input {
        width: 435px;
        height: 32px;
        border-radius: 4px;
        input {
          width: 100%;
          height: 100%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 22px;
          padding: 0 12px;
          border: 1px solid rgba(0, 0, 0, 0.15);
        }
      }
      & > span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        margin-left: 10px;
      }
      .el-button {
        width: 100px;
        height: 32px;
        padding: 0;
        border-radius: 4px;
        border: 1px solid rgba(255, 138, 1, 1);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 138, 1, 1);
        line-height: 22px;
        background: #fff;
      }
      .upload-demo {
        width: 435px;
      }
    }
    .formItemRightBt {
      width: 435px;
      height: 32px;
      display: flex;
      flex: none;
      .el-input {
        flex: 1;
      }
      .el-button {
        width: 73px;
        margin-left: 10px;
      }
    }
  }
  .formItemNext {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    button {
      width: 154px;
      height: 36px;
      background: rgba(255, 138, 1, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
      border: none;
      margin-right: 20px;
      cursor: pointer;
    }
    button:hover {
      opacity: 0.5;
    }
  }
}
</style>
